import * as React from "react";
import {useLocation} from "react-router-dom";

import {useTimeout} from "@khanacademy/wonder-blocks-timing";

/**
 * A hook that listens for a hash in the URL and focuses on an element with the
 * corresponding anchor if it is present in the document. This is only necessary
 * when you want to link directly to elements that are not present on initial
 * page load, e.g. asychronously-loaded content.
 */
export function useFocusAnchorToId(anchorId: string) {
    const location = useLocation();
    const element = React.useRef(null);
    // @ts-expect-error - TS2339 - Property 'focus' does not exist on type 'never'.
    const {set} = useTimeout(() => element?.current?.focus(), 0);
    function removeTargetFromTabOrder(event: Event) {
        if (event.target instanceof HTMLElement) {
            event.target.tabIndex = -1;
        }
    }

    React.useEffect(() => {
        if (location.hash.slice(1) !== anchorId) {
            return;
        }

        // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'null'.
        element.current = document.getElementById(anchorId);

        if (element.current) {
            const found = element.current;
            // @ts-expect-error - TS2339 - Property 'tabIndex' does not exist on type 'never'.
            found.tabIndex = 0;
            // @ts-expect-error - TS2339 - Property 'addEventListener' does not exist on type 'never'.
            found.addEventListener("blur", removeTargetFromTabOrder, {
                once: true,
            });
            set();
            return () => {
                // @ts-expect-error - TS2339 - Property 'removeEventListener' does not exist on type 'never'.
                found.removeEventListener("blur", removeTargetFromTabOrder);
            };
        }
    }, [anchorId, location.hash, set]);
}
